import { render, staticRenderFns } from "./VueTable.vue?vue&type=template&id=76bb1afd&scoped=true&"
import script from "./VueTable.vue?vue&type=script&lang=js&"
export * from "./VueTable.vue?vue&type=script&lang=js&"
import style0 from "./VueTable.vue?vue&type=style&index=0&id=76bb1afd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb1afd",
  null
  
)

export default component.exports